/**
 * Support for mmm-dd-yyyy format.
 * Jul-1-2018 or Jul-01-2018 is allowed.
 */
import { addLeadingZero, isDate } from "../DateUtils";
const months = {
  jan: 0,
  feb: 1,
  mar: 2,
  apr: 3,
  may: 4,
  jun: 5,
  jul: 6,
  aug: 7,
  sep: 8,
  oct: 9,
  nov: 10,
  dec: 11
};
export default {
  placeholder: () => "mmm-dd-yyyy",
  convertToDate: value => {
    const parsedDateValues = value.split("-");
    const year = parsedDateValues[2];
    const day = parsedDateValues[1];
    const month = months[parsedDateValues[0].toLowerCase()];
    return new Date(year, month, day);
  },
  convertToString: date => {
    if (isDate(date)) {
      const monthVal = date.getMonth();
      const month = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"][monthVal];
      return `${month}-${addLeadingZero(date.getDate())}-${date.getFullYear()}`;
    }

    return "";
  },
  customValidator: value => {
    const dateRegex = /^[A-z]{3}-\d{1,2}-\d{4}$/g;
    return dateRegex.test(value);
  },
  extractDayMonthYear: value => {
    const dateParts = value.split("-");
    return {
      day: Number(dateParts[1]),
      month: months[dateParts[0].toLowerCase()],
      year: Number(dateParts[2])
    };
  }
};